import React from 'react';
import PropTypes from 'prop-types';

/**
 * @typedef {Object} ContextMenuState
 * @property {number} top - Y position of context menu
 * @property {number} left - X position of context menu
 * @property {string} itemId - ID of item context menu is for
 * @property {Object} item - Full item data
 */

/**
 * @typedef {Object} TreeViewContextValue
 * @property {ContextMenuState|null} contextMenu - Current context menu state
 * @property {function(ContextMenuState|null): void} setContextMenu - Set context menu state
 */

/** @type {React.Context<TreeViewContextValue>} */
export const TreeViewContext = React.createContext({
  contextMenu: null,
  setContextMenu: () => {
    console.warn('TreeViewContext.Provider is not rendered');
  }
});

export const TreeViewProvider = ({ children, value }) => (
  <TreeViewContext.Provider value={value}>
    {children}
  </TreeViewContext.Provider>
);

TreeViewProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.shape({
    contextMenu: PropTypes.shape({
      top: PropTypes.number,
      left: PropTypes.number,
      itemId: PropTypes.string,
      item: PropTypes.object
    }),
    setContextMenu: PropTypes.func.isRequired
  }).isRequired
};

export const useTreeViewContext = () => {
  const context = React.useContext(TreeViewContext);
if (!context) {
    throw new Error('useTreeViewContext must be used within TreeViewProvider');
  }
  return context;
};

// Add displayName for better debugging
TreeViewContext.displayName = 'TreeViewContext';
TreeViewProvider.displayName = 'TreeViewProvider';
